import "slick-carousel";
jQuery(document).on('ready', () => {
    if (jQuery(window).width() < 576) {
        jQuery('.wm-mobileCarousel').each(function () {
            jQuery(this).slick({
                slidesToShow: 1,
                dots: true,
                arrows: true,
                infinite: false,
                centerMode: true
            });
        });
    }
    jQuery('.wm-caseCarousel__carousel').slick({
        slidesToShow: 1,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false
    });
});
